import { type FastAddDialogSettingsType } from 'app/main/modules/components/FastAddDialog';
// import { InlineTitle } from 'app/main/modules/components/FastAddDialogSettingsManager';

import SocialNetworksDetailsSectionInfo from './sections/SocialNetworksDetailsSectionInfo';

const dialogSettings: FastAddDialogSettingsType = {
	content: props => (
		<>
			{/* <InlineTitle text="DETAILS_INFO_SECTION" /> */}
			<SocialNetworksDetailsSectionInfo {...props} />
		</>
	)
};

export default dialogSettings;
